const APOLLO_ERROR_PREFIX = 'GraphQL error: ';
export const formatGraphQLErrorMessage = (error: Error) =>
  error.message.startsWith(APOLLO_ERROR_PREFIX)
    ? error.message.replace(APOLLO_ERROR_PREFIX, '')
    : error.message;
